// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2sPki","clinicsSelect":"TableHeading_clinicsSelect__19_KH"};